// NPM packages
import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { storyblokEditable } from '@storyblok/react';

// All other imports
import {
  ResourceCategoryListStoryblok,
  ResourceCategoryStoryblok,
} from 'types/storyblokTypes';
import LimitedResourceCategory from './LimitedResourceCategory';
import { Divider } from '@mui/material';
import { StoryblokStory } from 'storyblok-generate-ts';

const Root = styled.div(({ theme }) => ({
  marginBottom: '1.75rem',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

const DisplayArea = styled.div(({ theme }) => `
  min-width: ${theme.maxToolWidth};
  width: 100%;
  box-sizing: border-box;
  padding: 0 ${theme.typography.pxToRem(87)};

  @media (max-width: 1200px) {
    min-width: 0;
    width: 100%;
    padding: 0 ${theme.typography.pxToRem(43.5)};
  }

  @media (max-width: 600px) {
    padding: 0 1rem;
  }
`);

export interface ResourceCategoryListProps {
  blok: ResourceCategoryListStoryblok;
  className?: string;
}

function ResourceCategoryList(
  props: ResourceCategoryListProps
): React.ReactElement | null {
  const { blok, className } = props;
  const resourceCategories = blok.resourceCategories;
  const is_flipped = blok.align_images;
  return (
    <Root className={className}>
      <DisplayArea {...storyblokEditable(blok)}>
        {resourceCategories.map(
          (value: StoryblokStory<ResourceCategoryStoryblok> | string, idx) =>
            typeof value === 'object' && (
              <div key={`resourceCategory-${idx}`}>
                <LimitedResourceCategory
                  blok={value.content}
                  flipped={
                    is_flipped === undefined || !is_flipped
                      ? idx % 2 === 1
                      : false
                  }
                />
                <Divider />
              </div>
            )
        )}
      </DisplayArea>
    </Root>
  );
}

export default observer(ResourceCategoryList);
